import { useMemo } from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import useBinLevelBinProperties from '~/common/use-bin-level-bin-properties';
import { useLatestLevelFromPageNow } from '~/inventory/bin-props';

export function useLatestBinLevel({ binId }) {
  const { entity: binEntity, loading: binLoading } = useSirenEntity({ href: binId });
  const { entity: levelEntity, loading: levelLoading } = useLatestLevelFromPageNow({ binHref: binId });

  const response = useBinLevelCommon({ binId, binEntity, levelEntity, loading: levelLoading || binLoading });
  return {
    ...response,
    latestLevel: response?.levelEntity,
  };
}

function useBinLevelCommon({ binId, binEntity, levelEntity, loading }) {
  const {
    binLevelProperties,
    loading: binLevelPropertiesLoading,
  } = useBinLevelBinProperties({ binId });

  const useSmoothedValues = binLevelProperties?.properties?.smoothingModel !== 'none';
  const volume = useSmoothedValues
    ? (levelEntity?.properties?.estimatedVolume ?? levelEntity?.properties?.volume ?? 0)
    : (levelEntity?.properties?.volume ?? 0);

  const weight = useSmoothedValues
    ? (levelEntity?.properties?.estimatedWeight ?? levelEntity?.properties?.weight ?? 0)
    : (levelEntity?.properties?.weight ?? 0);

  const loadingFinal = !binEntity || loading || binLevelPropertiesLoading;

  return useMemo(() => ({
    volume,
    weight,
    publishedAt: levelEntity?.properties?.publishedAt,
    loading: loadingFinal,
    levelEntity,
  }), [levelEntity, loadingFinal, volume, weight]);
}
